import React, { Fragment } from 'react';
import { Checkbox } from '@vds/checkboxes';
import PropTypes from 'prop-types';

// checkbox component.
const CheckBox = (props) => {
  const {
    name,
    width,
    type,
    className,
    error,
    errorText,
    id,
    surface,
    onChange,
    analyticstrack,
    dataTrack,
    ariaLabel,
    isDisabled,
    selected,
    children,
    label,
    ...otherProps
  } = props;
  return (
    <Fragment>
      <Checkbox
        name={name}
        width={width}
        inputId={id}
        type={type}
        className={className}
        onChange={onChange}
        data-analyticstrack={analyticstrack}
        data-track={dataTrack || ''}
        label={label}
        ariaLabel={ariaLabel}
        disabled={isDisabled}
        checked={selected}
        error={error}
        errorText={errorText}
        surface={surface}
        selected={selected}
        {...otherProps}
      >
        {children}
      </Checkbox>
    </Fragment>
  );
};

CheckBox.defaultProps = {
  surface: 'light',
};

CheckBox.propTypes = {
  name: PropTypes.string,
  isDisabled: PropTypes.bool,
  ariaLabel: PropTypes.string,
  onChange: PropTypes.func,
  analyticstrack: PropTypes.string,
  selected: PropTypes.bool,
  id: PropTypes.string,
  children: PropTypes.any,
  dataTrack: PropTypes.string,
  width: PropTypes.string,
  error: PropTypes.bool,
  errorText: PropTypes.string,
  surface: PropTypes.oneOf(['light', 'dark']),
  className: PropTypes.string,
  type: PropTypes.string,
  label: PropTypes.string,
};

export default CheckBox;
